const assignment = {
  id: 0,
  userId: null,
  billRate: null,
  startAt: null,
  endAt: null,
  contractTypeId: null,
  lengthOfContract: null,
  conversionFee: null,
  employeeTypeId: null,
  corporateName: null,
  active: true,
  clientId: null,
  overtimeEligible: null,
  billRateTypeId: null,
  payFrequencyId: null,
  payRateTypeId: null,
  payRate: null,
  ein: null,
  commissions: [],
  expenses: [],
  timeTypeRates: [],
  defaultExpensesByClient: [],
  expensesDeduction: 0,
  vmsFee: null,
  workedHoursAverage: null,
  jobTitle: null,
  timeSheetType: 2,
  clockIPAddress: null,
  overtimeThreshold: null,
  overtimeRate: null,
  contractorCommissionEnabled: false,
  contractorCommissionMarkup: 0,
  vmsAssignmentId: null
}

export default () => Object.assign({}, assignment)

export const getAssignmentTemplate = (source) => JSON.parse(JSON.stringify(source))
